module.exports = __webpack_public_path__ + "static/drweb-3129094bbb794d9bdccd3e0b11d1b33d.jpg";